export default "__VITE_ASSET__CMJnfF4$__"